import { useAuth0 } from "@auth0/auth0-react";

const frontend_hypertext = process.env.REACT_APP_FRONTEND_HYPERTEXT;
const frontend_domain = process.env.REACT_APP_FRONTEND_DOMAIN;
const frontend_port = process.env.REACT_APP_FRONTEND_PORT;

const LoginButton = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  console.log(
    `${frontend_hypertext}${frontend_domain}${frontend_port}/profile`
  );
  return (
    <>
      {!isAuthenticated && ( // returns sign out button if user is authenticated, else returns blank
        <button
          className="bg-primary-500 hover:bg-primary-700 text-white font-bold py-2 px-4 border border-primary-700 rounded"
          onClick={() =>
            loginWithRedirect({
              redirectUri: `${frontend_hypertext}${frontend_domain}${frontend_port}/profile`,
            })
          }
        >
          Sign in
        </button>
      )}
    </>
  );
};

export default LoginButton;
